import React, { useContext } from "react"
import { Link } from "gatsby"

import { useTranslation } from "react-i18next"

import BaseTitle from "../Title"
import BaseDescription from "../Description"
import BaseTertiaryButton from "../TertiaryButton"
import BaseParchment from "../Parchment"
import BaseSecondaryButton from "../SecondaryButton"

import CustomImage from "../../CustomImage"

import { BookModalContext } from "../../../context/bookModalContext"

const BaseRoomCard = ({
  title,
  bookingId,
  description,
  className,
  thumbnailImage,
  path,
  light = true,
  imageHasBorder = false,
  isAvailable = true,
  openingInformation = "",
}) => {
  const { setIsOpen, setBookingId } = useContext(BookModalContext)
  const { t } = useTranslation()

  const displayModalBookRoom = () => {
    setBookingId(bookingId)
    setIsOpen(true)
    document.querySelector("body").style.overflowY = "hidden"
  }
  return (
    <BaseParchment
      className={`max-w-md px-2 pt-4 pb-6 ${className}`}
      light={light}
    >
      <Link to={path}>
        <CustomImage
          image={thumbnailImage}
          alt={title}
          className="w-full mb-6"
          typeFrame="landscape"
          hasBorder={imageHasBorder}
        />
      </Link>
      <div className="mb-6">
        <Link to={path}>
          <BaseTitle title={title} className="mb-6" />
          {!!openingInformation && (
            <BaseDescription
              description={openingInformation}
              className="font-semibold mb-4 underline"
            ></BaseDescription>
          )}
        </Link>
        {!isAvailable ? (
          <BaseDescription
            description={t("room.toCome")}
            className="text-center text-action font-semibold mb-6"
          />
        ) : null}
        <BaseDescription
          description={description}
          className="text-justify mb-6"
        />
      </div>
      <div className="flex justify-end items-center xs:flex-col xs:items-center">
        <BaseTertiaryButton
          text={t("utils.prices")}
          className="xs:mb-12 mr-0 sm:mr-4"
          path={path}
        />
        {isAvailable ? (
          <BaseSecondaryButton
            text={t("utils.book")}
            onClick={displayModalBookRoom}
          />
        ) : (
          ""
        )}
      </div>
    </BaseParchment>
  )
}

export default BaseRoomCard
